<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/lockUserList')">禁用用户列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type="month"
                placeholder="月份"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

          </el-form-item>
          <el-form-item label="团队">
            <el-select
              v-model="filters.infoType"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="陈"
                value="1"
              ></el-option>
              <el-option
                label="孙"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="代理类型">
            <el-select
              v-model="filters.roleType"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="康减系列市代"
                value="1.1"
              ></el-option>
              <el-option
                label="康减系列省代"
                value="2.1"
              ></el-option>
              <el-option
                label="康减系列CEO"
                value="3.1"
              ></el-option>
              <el-option
                label="市代"
                value="2"
              ></el-option>
              <el-option
                label="省代"
                value="3"
              ></el-option>
              <el-option
                label="CEO"
                value="4"
              ></el-option>
              <el-option
                label="总经销商"
                value="5"
              ></el-option>
              <el-option
                label="合伙人"
                value="2.2"
              ></el-option>
              <el-option
                label="董事"
                value="4.2"
              ></el-option>
                <el-option label="经销商" value="4.8"></el-option>
              <el-option
                label="区域总监"
                value="5.1"
              ></el-option>
              <el-option
                label="城市加盟商"
                value="5.2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          ref="dataTable"
          :data="tableData"
          style="width: 100%"
          :height="tableHeight"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            label="代理姓名"
            prop="username"
          >
          <template slot-scope="scope">
              <a
                style="color:blue;cursor: pointer;"
                @click="goDetail(scope.row)"
              >{{scope.row.username}}</a>
            </template>
          </el-table-column>

          <el-table-column
            prop="role_type"
            :formatter="formatterRoleType"
            label="代理类型"
          >
          </el-table-column>

          <el-table-column
            prop="group_type"
            label="团队"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.group_type == 1">陈</span>
            <span v-else>孙</span>
          </template>
          </el-table-column>


          <el-table-column
            label="禁用时间"
            prop="create_time"
          >
          </el-table-column>

        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>


  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
export default {
  name: "checkList",
  created() {},

  data() {
    return {
      loading: false,
      filters: {
        roleType: null,
        infoType:null,
        startTime:null
      },
      page_num: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    goDetail(row) {
      this.$router.push({ path: "/user_detail", query: { id: row.id, back:1 } });
    },
    formatterRoleType(row, column) {
      if (row.role_type == -1) {
        return "无";
      } else if (row.role_type == -0.5) {
        return "康减系列VIP会员";
      } else if (row.role_type == -0.4) {
        return "康减系列荣誉会员";
      } else if (row.role_type == -0.3) {
        return "康减系列高级会员";
      } else if (row.role_type == 0) {
        return "VIP门店";
      } else if (row.role_type == 1) {
        return "联盟店";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 2) {
        return "市代";
      } else if (row.role_type == 3) {
        return "省代";
      } else if (row.role_type == 4) {
        return "CEO";
      } else if (row.role_type == 1.1) {
        return "康减系列市代";
      } else if (row.role_type == 2.1) {
        return "康减系列省代";
      } else if (row.role_type == 3.1) {
        return "康减系列CEO";
      } else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      }  else if (row.role_type == 4.8) {
        return "经销商";
      }
    },

    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        page_num: that.page_num,
        page_size: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.roleType) {
        params.roleType = that.filters.roleType;
      }
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      }
      if (that.filters.infoType) {
        params.infoType = that.filters.infoType;
      }
      that.loading = true;

      API.lock_user_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
              }
              that.tableData = result.result.list;
            } else if (result.key == 1001) {
              bus.$emit("goto", "/login");
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/lockUserList.vue